import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  showMenu: boolean = false;
  title = 'indorz-ui-web';
  isLoggedIn: boolean;
  currentCompanyId: string | null = null
  constructor(private authService: AuthService) {
    authService.loggedInUser$.subscribe(result => {
      this.isLoggedIn = !!result;
    })
    if (!this.currentCompanyId && localStorage.getItem('currentCompany')) {
      let company = JSON.parse(localStorage.getItem('currentCompany'));

      // this.currentCompany = company ? company.name : null
      this.currentCompanyId = company ? company._id : null
    }

  }
}
